import React, { useCallback, useState } from 'react';
import { Form, Button } from 'semantic-ui-react';
import { Icon } from 'src/components/shared';
import { getErrorMessage } from 'src/utils/form-utils';
import { brazeHandleNewsletter } from 'src/utils/sdk-utils';

import * as Styles from 'src/styles/stay-in-touch.module.scss';

const StayInTouch = () => {
    const [emailValue, setEmailValue] = useState('');
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('Please enter an email address');

    const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;

    const handleEmail = useCallback(() => {
        if (showError) {
            setShowError(false);
        }

        if (emailRegex.test(emailValue)) {
            sendEmail(emailValue);
        } else {
            setErrorMessage('Please enter an email address');
            setShowError(true);
        }
    }, [emailValue]);

    const sendEmail = useCallback(
        async (email: string) => {
            try {
                const date = new Date().toISOString();
                const message = await brazeHandleNewsletter(email, date);

                if (message === 'success') {
                    setShowSuccess(true);
                } else {
                    setErrorMessage("Email couldn't be sent. Please try it again later");
                    setShowError(true);
                }
            } catch (error) {
                console.log(error);
            }
        },
        [emailValue]
    );

    return (
        <div>
            <h6 className={Styles.stayInTouchTitle}>Let's stay in touch</h6>
            <p className={Styles.stayInTouchDescription}>
                Get fitness tips, tricks and motivations right in your inbox. But don’t worry, not
                too often.
            </p>
            <Form onSubmit={handleEmail} className={Styles.stayInTouchInputContainer}>
                {showSuccess ? (
                    <div className={Styles.stayInTouchSuccess}>
                        <Icon size={15} name="pv-checkmark-circle" color="teal" />
                        <span>Subscribed! Thanks for signing up!</span>
                    </div>
                ) : (
                    <>
                        <Form.Input
                            className={Styles.stayInTouchInput}
                            id="email"
                            name="email"
                            type="text"
                            placeholder="email"
                            onChange={(e) => {
                                setEmailValue(e.target.value);
                            }}
                            error={showError && getErrorMessage(errorMessage)}
                        />
                        <Button className={Styles.stayInTouchBtn} color="blue" circular>
                            <Icon size={24} name="pv-arrow-right" color="white" />
                        </Button>
                    </>
                )}
            </Form>
        </div>
    );
};

export default StayInTouch;
